import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Stack,
  useTheme,
  useMediaQuery,
  alpha,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  keyframes,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CtBtn from "../CustomTool/CtBtn";
import DashboardPreview from "../../Images/HeroHome.png";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import React, { useState } from "react";
import BookingDialog from "../BookingDialog";

// Animation for floating effect
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

// Animation for gradient background
const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

function HomeHero() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openBooking, setOpenBooking] = useState(false);
  const [open, setOpen] = useState(false);
  const [eventTitle, setEventTitle] = useState("Book Demo with RiTe Account");
  const [eventDescription, setEventDescription] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs());

  // Generate Google Calendar link

  // const BookADemo = (eventTitle, eventDescription, selectedDate) => {
  //   window.location.href = `mailto:faizanssheikh5656@gmail.com?subject=${encodeURIComponent(
  //     eventTitle
  //   )}&body=${encodeURIComponent(
  //     eventDescription + "\nDate: " + selectedDate
  //   )}`;
  // };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, md: 4 },
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.light,
          0.05
        )} 0%, ${alpha(theme.palette.primary.main, 0.1)} 100%)`,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          width: "500px",
          height: "500px",
          right: "-250px",
          top: "-250px",
          borderRadius: "50%",
          background: `radial-gradient(${alpha(
            theme.palette.primary.main,
            0.1
          )} 0%, transparent 70%)`,
          animation: `${float} 15s ease-in-out infinite`,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          left: "-200px",
          bottom: "-200px",
          borderRadius: "50%",
          background: `radial-gradient(${alpha(
            theme.palette.secondary.main,
            0.1
          )} 0%, transparent 70%)`,
          animation: `${float} 18s ease-in-out infinite`,
          animationDelay: "1s",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Grid
          container
          spacing={6}
          alignItems="center"
          justifyContent="space-between"
          sx={{
            maxWidth: 1280,
            mx: "auto",
          }}
          direction={isMobile ? "column-reverse" : "row"}
        >
          {/* Left Content */}
          <Grid size={{ xs: 12, md: 7 }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 3,
                lineHeight: 1.1,
                color: "text.primary",
                fontSize: { xs: "2.5rem", md: "3.5rem" },
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                backgroundClip: "text",
                textFillColor: "transparent",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Smart GST Accounting <br /> for Modern Businesses
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 4,
                color: "text.secondary",
                fontWeight: 400,
                lineHeight: 1.6,
                maxWidth: "100%",
              }}
            >
              Invoicing, Sales, Purchase, Payments, Inventory and GST filing—all
              in one place.
              <br />
              Generate e-Invoice and e-Way bills seamlessly.
            </Typography>

            {/* Buttons */}
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              sx={{ mb: 6 }}
            >
              <CtBtn
                variant="contained"
                size="large"
                sx={{
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  borderRadius: 2,
                  background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  boxShadow: `0 4px 20px ${alpha(
                    theme.palette.primary.main,
                    0.4
                  )}`,
                  transition: "all 0.3s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: `0 8px 25px ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    background: `linear-gradient(45deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                  },
                }}
                label="Start Free Trial"
                onClick={() => {
                  const url = `https://accounts.ravitechworld.com/`;
                  window.open(url, "_blank"); // new tab me open karega
                }}

              />
              <CtBtn
                variant="outlined"
                size="large"
                onClick={() => setOpenBooking(true)}
                // onClick={() => {
                //   const adminNumber = "918000516051";
                //   const message =
                //     "Hello, I would like to book a demo for Smart GST Accounting.";
                //   const url = `https://wa.me/${adminNumber}?text=${encodeURIComponent(
                //     message
                //   )}`;

                //   window.open(url, "_blank"); // new tab me open karega
                // }}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  borderRadius: 2,
                  borderWidth: 2,
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  transition: "all 0.3s",
                  "&:hover": {
                    borderWidth: 2,
                    borderColor: theme.palette.primary.dark,
                    backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    transform: "translateY(-2px)",
                  },
                }}
                label="Book a Demo"
              />
            </Stack>

            {/* Stats */}
            <Grid container spacing={2} sx={{ maxWidth: 600 }}>
              {[
                { value: "1L+", label: "Happy Users" },
                { value: "4.7/5", label: "Avg Rating" },
                { value: "Multi-Device", label: "Web & Mobile" },
                { value: "Multi-User", label: "User Management" },
              ].map((item, index) => (
                <Grid item xs={6} sm={3} key={index}>
                  <Box
                    sx={{
                      textAlign: "center",
                      p: 2,
                      borderRadius: 2,
                      background: alpha(theme.palette.background.paper, 0.8),
                      boxShadow: `0 4px 15px ${alpha(
                        theme.palette.common.black,
                        0.05
                      )}`,
                      transition: "all 0.3s",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: `0 8px 25px ${alpha(
                          theme.palette.common.black,
                          0.1
                        )}`,
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "1.4rem",
                        color: theme.palette.primary.dark,
                        mb: 0.5,
                      }}
                    >
                      {item.value}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        lineHeight: 1.2,
                        fontSize: "0.8rem",
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Right Side - Image Preview */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Box
              component="img"
              src={DashboardPreview}
              alt="Dashboard Preview"
              sx={{
                width: "110%",
                height: "auto",
                display: "block",
              }}
            />

            {!isMobile && (
              <>
                <Box
                  sx={{
                    position: "absolute",
                    right: 60,
                    top: "40%",
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: `linear-gradient(45deg, ${alpha(
                      theme.palette.primary.main,
                      0.1
                    )} 0%, transparent 70%)`,
                    animation: `${float} 8s ease-in-out infinite`,
                    zIndex: -1,
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    right: 120,
                    bottom: 80,
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    background: `linear-gradient(45deg, ${alpha(
                      theme.palette.secondary.main,
                      0.1
                    )} 0%, transparent 70%)`,
                    animation: `${float} 10s ease-in-out infinite`,
                    animationDelay: "0.5s",
                    zIndex: -1,
                  }}
                />
              </>
            )}
          </Grid>
        </Grid>
      </Box>
      {/* <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Schedule a Demo</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <TextField
              label="Demo Title"
              value={eventTitle}
              onChange={(e) => setEventTitle(e.target.value)}
              fullWidth
            />


            <TextField
              label="Description"
              value={eventDescription}
              onChange={(e) => setEventDescription(e.target.value)}
              fullWidth
              multiline
              rows={3}
            />

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Select Date & Time"
                value={selectedDate}
                onChange={(newValue) => setSelectedDate(newValue)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Button
              onClick={BookADemo}
              variant="contained"
              sx={{ borderRadius: 2 }}
            >
              Book a Demo
            </Button>
          </Box>
        </DialogContent>
      </Dialog> */}
      <BookingDialog open={openBooking} onClose={() => setOpenBooking(false)} />
    </Box>
  );
}

export default HomeHero;
